import { defineStore } from 'pinia';
import router from '@/router';

const useAppsStore = defineStore('apps', {
    state: () => ({
        items: [
            {
                featured: true,
                freemium: true,
                url: 'https://miracle.bilbomusic.com',
                author: {
                    name: 'Bilbo Labs'
                },
                code: 'miracle',
                name: 'Miracle'
            }
        ]
    }),
    getters: {
        featured: (state) => state.items.find(item => item.featured),
    },
    actions: {
    }
});

export default useAppsStore;
